import LogoutIcon from '@mui/icons-material/Logout';
import { Button, FormControlLabel, Grid, IconButton, Menu, MenuItem, Switch } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/authWindows';
import { useTranslation } from '../../../contexts/translation';
import { useLocalTheme } from '../../../hooks/useLocalTheme';
import { paths } from '../../../utils/core/routes';

export function NavMenuProfile() {
  const { t } = useTranslation();
  const { user, signOut } = useAuth();
  const theme = useTheme();
  const navigate = useNavigate();
  const { localTheme, changeLocalTheme } = useLocalTheme();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    if (signOut) signOut();
    navigate(paths.HOME);
  };

  return (
    <>
      <Grid container alignItems={'center'} justifyContent={'end'}>
        <Typography variant="h6" noWrap component="div" textAlign={'left'} style={{ flexGrow: 1 }}>
          {t('navigation.headline-app-name')}
        </Typography>
        <Grid
          item
          xs={1.7}
          alignContent={'right'}
          style={{ display: 'flex', marginRight: 10 }}
          justifyContent={'end'}
        >
          <FormControlLabel
            control={
              <Switch
                checked={localTheme === 'dark'}
                onChange={() => {
                  changeLocalTheme();
                }}
                style={{ float: 'right', cursor: 'pointer' }}
                name="dark"
                size="medium"
                color="default"
              />
            }
            label={<Typography variant="h6">Dark</Typography>}
          />
        </Grid>
        <Grid
          item
          xs={1.5}
          alignContent={'right'}
          style={{ display: 'flex' }}
          justifyContent={'end'}
        >
          <Typography
            variant="h6"
            noWrap
            component="div"
            textAlign={'right'}
            style={{ flexGrow: 1 }}
          >
            {user ? (
              <div>
                <Button
                  id="demo-positioned-button"
                  aria-controls={open ? 'demo-positioned-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                >
                  {user.name}
                </Button>
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  <MenuItem onClick={handleClose}>
                    <IconButton
                      title="Logout"
                      aria-label="Logout"
                      size="small"
                      onClick={handleLogout}
                    >
                      <LogoutIcon fontSize="small" style={{ marginRight: '20px' }} />
                      {t('general.action-buttons.log-out')}
                    </IconButton>
                  </MenuItem>
                </Menu>
              </div>
            ) : (
              <Link
                to={`${paths.LOGIN_PAGE}`}
                style={{ color: theme.palette.primary.main, fontWeight: 600 }}
              >
                {t('general.action-buttons.log-in')}
              </Link>
            )}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
